<div class="cinephile-page">
  <!-- Cinematic Ambient Background Layers -->
  <div class="grain" aria-hidden="true"></div>
  <div class="projector-glow" aria-hidden="true"></div>
  <div class="ambient-leak leak-left" aria-hidden="true"></div>
  <div class="ambient-leak leak-right" aria-hidden="true"></div>

  <!-- Loading Screen -->
  <div class="loading-screen" *ngIf="loading">
    <div class="loader-ring"></div>
    <p class="loading-title">Loading Cinephile Arena...</p>
    <p class="loading-sub">Preparing today's film screenings</p>
  </div>

  <!-- Error State -->
  <div class="error-state" *ngIf="!loading && error">
    <div class="error-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>
    <h2>Screening Unavailable</h2>
    <p>{{ error }}</p>
  </div>

  <!-- Main Content -->
  <div class="container dashboard-main" *ngIf="!loading && !error">

    <!-- ── Full-Width Cinephile Hero Marquee ────────────────────────── -->
    <section class="hero-banner">
      <div class="hero-banner-bg"></div>
      <div class="scanlines"></div>

      <div class="hero-banner-content">
        <div class="hero-eyebrow-wrap">
          <span class="hero-eyebrow">
            <span class="sparkle">✦</span>
            <span>Premiere Screening Lounge</span>
            <span class="sparkle">✦</span>
          </span>
        </div>
        <h1 class="hero-title">CINEPHILE</h1>
        <p class="hero-subtitle">The Ultimate Cinema Quiz Arena</p>
        <p class="hero-sub">
          Step into the screening room. Test your film mastery across legendary auteurs, golden eras, and deep cinema trivia. Climb the leaderboard, earn admission tickets, and unlock exclusive vintage film posters.
        </p>

        <div class="hero-actions">
          <button class="btn-primary btn-lg" *ngIf="dailyQuiz" (click)="playDaily()" title="Enter Today's Screening">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <polygon points="6 3 20 12 6 21 6 3"/>
            </svg>
            <span>Play Daily Screening</span>
          </button>
          <button class="btn-outline btn-lg" (click)="scrollToQuizzes()" title="Explore Screenings Repertoire">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <circle cx="12" cy="12" r="3.5"/>
              <line x1="12" y1="2" x2="12" y2="8.5"/>
              <line x1="12" y1="15.5" x2="12" y2="22"/>
              <line x1="2" y1="12" x2="8.5" y2="12"/>
              <line x1="15.5" y1="12" x2="22" y2="12"/>
            </svg>
            <span>Explore Screenings</span>
          </button>
        </div>
      </div>

      <!-- Spotlight Feature Card -->
      <div class="hero-spotlight" *ngIf="dailyQuiz">
        <div class="spotlight-card" (click)="playDaily()">
          <div class="spotlight-header">
            <span class="spotlight-live-badge">
              <span class="pulse-dot"></span>
              TODAY'S SCREENING
            </span>
            <span class="spotlight-bonus">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
              <span>+50 Bonus</span>
            </span>
          </div>

          <div class="spotlight-body">
            <div class="spotlight-icon">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="M2 8h20"/>
                <path d="m6 4 3 4"/>
                <path d="m11 4 3 4"/>
                <path d="m16 4 3 4"/>
              </svg>
            </div>
            <div class="spotlight-info">
              <h3 class="spotlight-title">{{ dailyQuiz.title }}</h3>
              <p class="spotlight-meta">
                <span>{{ dailyQuiz.question_ids.length || '?' }} Questions</span>
                <span class="meta-dot">&middot;</span>
                <span>{{ dailyQuiz.time_limit ? dailyQuiz.time_limit + ' min' : '25s / Q' }}</span>
              </p>
            </div>
          </div>

          <div class="spotlight-footer">
            <span class="spotlight-cta-text">Enter Theatre</span>
            <div class="spotlight-cta-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ── Stats Credentials Bar (Full Width with Teal SVGs) ─────────────── -->
    <section class="stats-bar">
      <div class="stats-bar-inner">
        <!-- 1. Tickets -->
        <div class="stat-pill" title="Current Cinephile Admission Tickets">
          <div class="stat-pill-icon-wrap teal">
            <svg class="stat-pill-svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/>
              <path d="M13 5v2"/>
              <path d="M13 11v2"/>
              <path d="M13 17v2"/>
            </svg>
          </div>
          <div class="stat-pill-content">
            <div class="stat-pill-header">
              <span class="stat-pill-val">{{ (stats?.tickets || 0) | number }}</span>
            </div>
            <span class="stat-pill-lbl">Tickets</span>
          </div>
        </div>

        <div class="stat-divider"></div>

        <!-- 2. Day Streak -->
        <div class="stat-pill" title="Consecutive Day Trivia Streak">
          <div class="stat-pill-icon-wrap amber">
            <svg class="stat-pill-svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 3z"/>
            </svg>
          </div>
          <div class="stat-pill-content">
            <div class="stat-pill-header">
              <span class="stat-pill-val">{{ stats?.current_streak || 0 }}</span>
            </div>
            <span class="stat-pill-lbl">Day Streak</span>
          </div>
        </div>

        <div class="stat-divider"></div>

        <!-- 3. Global Rank -->
        <div class="stat-pill" title="Worldwide Cinephile Leaderboard Rank">
          <div class="stat-pill-icon-wrap gold">
            <svg class="stat-pill-svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
              <path d="M4 22h16"/>
              <path d="M10 14.66V17c0 .55-.45 1-1 1H7v4h10v-4h-2c-.55 0-1-.45-1-1v-2.34"/>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
            </svg>
          </div>
          <div class="stat-pill-content">
            <div class="stat-pill-header">
              <span class="stat-pill-val">{{ rankDisplay }}</span>
            </div>
            <span class="stat-pill-lbl">Global Rank</span>
          </div>
        </div>

        <div class="stat-divider"></div>

        <!-- 4. Vault Posters -->
        <div class="stat-pill" title="Unlocked Vintage Film Posters">
          <div class="stat-pill-icon-wrap emerald">
            <svg class="stat-pill-svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
              <circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21 15 16 10 5 21"/>
            </svg>
          </div>
          <div class="stat-pill-content">
            <div class="stat-pill-header">
              <span class="stat-pill-val">{{ stats?.unlocked_poster_count || 0 }}</span>
            </div>
            <span class="stat-pill-lbl">Vault Posters</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ── Director Dossier & Hub Navigation ─────────────────────────── -->
    <section class="profile-section">
      <div class="profile-inner">
        <div class="profile-card">
          <div class="avatar-ring">
            <div class="avatar-inner">
              <ng-container *ngIf="stats?.avatar; else defaultAvatar">
                <span class="avatar-custom">{{ stats?.avatar }}</span>
              </ng-container>
              <ng-template #defaultAvatar>
                <svg class="avatar-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M23 7l-7 5 7 5V7z"/>
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                </svg>
              </ng-template>
            </div>
          </div>
          <div class="profile-details">
            <div class="profile-role-row">
              <span class="director-tag">DIRECTOR ON SET</span>
            </div>
            <h3 class="profile-name">{{ stats?.display_name || 'Cinephile' }}</h3>
            <div class="profile-badge-row">
              <span class="rank-badge">
                <span class="badge-sparkle">✦</span>
                <span>{{ stats?.producer_title || 'Film Buff' }}</span>
              </span>
            </div>
          </div>
          <div class="profile-accuracy">
            <span class="accuracy-val">{{ accuracy }}</span>
            <span class="accuracy-lbl">Accuracy</span>
          </div>
        </div>

        <div class="quick-links">
          <!-- Closing Credits (Leaderboard) -->
          <a routerLink="/quiz/leaderboard" class="qlink" title="View Worldwide Standings">
            <div class="qlink-icon-wrap teal">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
                <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
                <path d="M4 22h16"/>
                <path d="M10 14.66V17c0 .55-.45 1-1 1H7v4h10v-4h-2c-.55 0-1-.45-1-1v-2.34"/>
                <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
              </svg>
            </div>
            <div class="qlink-text">
              <span class="qlink-title">Closing Credits</span>
              <span class="qlink-sub">Worldwide cinephile rankings</span>
            </div>
            <svg class="qlink-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </a>

          <!-- The Vault -->
          <a routerLink="/quiz/vault" class="qlink" title="Explore Poster Archives">
            <div class="qlink-icon-wrap emerald">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
            </div>
            <div class="qlink-text">
              <span class="qlink-title">The Vault</span>
              <span class="qlink-sub">Collectible vintage film posters</span>
            </div>
            <svg class="qlink-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </a>
        </div>
      </div>
    </section>

    <!-- ── Screening History & Category Mastery Section (Grid 2) ── -->
    <section class="history-mastery-section" *ngIf="quizHistory?.history && quizHistory!.history.length > 0">
      <div class="mastery-grid-2">

        <!-- Card 1: Best Genre Spotlight Card -->
        <div class="best-category-card" *ngIf="quizHistory?.best_category">
          <div class="bc-badge-row">
            <span class="bc-crown-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
              <span>YOUR STRONGEST GENRE</span>
            </span>
            <span class="bc-accuracy-pill">{{ quizHistory?.best_category?.accuracy }}% Accuracy</span>
          </div>

          <div class="bc-main">
            <div class="bc-icon-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </div>
            <div class="bc-info">
              <h3 class="bc-category-name">{{ quizHistory?.best_category?.category_name }}</h3>
              <p class="bc-stats-line">
                <span class="bc-stat-num">{{ quizHistory?.best_category?.quizzes_played }}</span> Screenings Completed
                <span class="meta-sep">&middot;</span>
                <span class="bc-stat-correct">{{ quizHistory?.best_category?.correct_answers }} Correct</span>
                <span class="meta-sep">&middot;</span>
                <span class="bc-stat-wrong">{{ quizHistory?.best_category?.wrong_answers }} Misses</span>
              </p>
            </div>
          </div>
        </div>

        <!-- Card 1 Fallback if best_category not calculated yet -->
        <div class="best-category-card" *ngIf="!quizHistory?.best_category">
          <div class="bc-badge-row">
            <span class="bc-crown-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
              <span>GENRE MASTERY</span>
            </span>
            <span class="bc-accuracy-pill">{{ quizHistory?.overall_accuracy || 0 }}% Accuracy</span>
          </div>

          <div class="bc-main">
            <div class="bc-icon-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </div>
            <div class="bc-info">
              <h3 class="bc-category-name">{{ quizHistory?.history?.[0]?.category_name || 'General Cinema' }}</h3>
              <p class="bc-stats-line">
                <span class="bc-stat-num">{{ quizHistory?.total_quizzes }}</span> Screenings Completed
                <span class="meta-sep">&middot;</span>
                <span class="bc-stat-correct">{{ quizHistory?.total_correct }} Correct</span>
                <span class="meta-sep">&middot;</span>
                <span class="bc-stat-wrong">{{ quizHistory?.total_wrong }} Misses</span>
              </p>
            </div>
          </div>
        </div>

        <!-- Card 2: Screening Reel History Gateway Card (Links to /quiz/history) -->
        <a class="history-gateway-card" [routerLink]="['/quiz/history']" role="button" tabindex="0">
          <div class="hg-badge-row">
            <span class="hg-reel-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3.5"/><line x1="12" y1="2" x2="12" y2="8.5"/>
              </svg>
              <span>SCREENING LOG REEL</span>
            </span>
            <span class="hg-count-pill">{{ quizHistory?.total_quizzes }} Played</span>
          </div>

          <div class="hg-main">
            <div class="hg-icon-box">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/><line x1="17" y1="17" x2="22" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/>
              </svg>
            </div>
            <div class="hg-info">
              <h3 class="hg-title">Your Screening History</h3>
              <p class="hg-stats-line">
                <span class="bc-stat-correct">{{ quizHistory?.total_correct }} Right Answers</span>
                <span class="meta-sep">&middot;</span>
                <span class="bc-stat-wrong">{{ quizHistory?.total_wrong }} Misses</span>
              </p>
            </div>
          </div>

          <div class="hg-cta-row">
            <span class="hg-cta-text">Open Full History & Answers Page</span>
            <div class="hg-cta-arrow">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
          </div>
        </a>

      </div>
    </section>

    <!-- ── Full Screening Reel Inspector Modal (Responsive for all devices) ── -->
    <div class="screening-inspector-backdrop" *ngIf="isHistoryModalOpen" (click)="closeHistoryModal()">
      <div class="screening-inspector-modal" (click)="$event.stopPropagation()">
        
        <!-- Modal Header -->
        <div class="sim-header">
          <div class="sim-title-group">
            <div class="sim-badge-row">
              <span class="sim-badge">✦ DIRECTOR'S SCREENING REEL</span>
              <span class="sim-count">{{ quizHistory?.total_quizzes }} Screenings Recorded</span>
            </div>
            <h2 class="sim-heading">Your Screening History & Answer Breakdown</h2>
            <p class="sim-sub">Click any screening card to inspect scene questions, your chosen takes, correct answers, and director's cut reasoning.</p>
          </div>
          <button type="button" class="btn-close-sim" (click)="closeHistoryModal()" aria-label="Close Inspector">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <!-- Modal Body: List of Played Game Cards -->
        <div class="sim-body">
          <div class="sim-game-card" *ngFor="let item of quizHistory?.history" [class.expanded]="expandedAttemptId === (item.attempt_id || item._id)">
            
            <!-- Card Bar (Click to toggle scene review) -->
            <div class="sim-card-bar" (click)="toggleAttemptExpand(item.attempt_id || item._id!)" role="button" tabindex="0">
              <div class="sim-bar-left">
                <div class="sim-date-time">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                  </svg>
                  <span>{{ item.played_at | date:'medium' }}</span>
                </div>
                <h3 class="sim-quiz-title">{{ item.quiz_title }}</h3>
                <span class="sim-cat-tag">🎬 {{ item.category_name }}</span>
              </div>

              <div class="sim-bar-mid">
                <div class="h-answers-pill">
                  <span class="h-correct">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    {{ item.correct_answers }} Right
                  </span>
                  <span class="h-sep">/</span>
                  <span class="h-wrong">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    {{ item.wrong_answers }} Wrong
                  </span>
                </div>
                <span class="h-rank-tag">{{ item.rank_title }}</span>
              </div>

              <div class="sim-bar-right">
                <div class="h-score-badge" [class.pass]="item.score_pct >= 50" [class.fail]="item.score_pct < 50">
                  <span class="h-score-val">{{ item.score_pct | number:'1.0-0' }}%</span>
                  <span class="h-score-lbl">Score</span>
                </div>
                <div class="h-tickets-badge" *ngIf="item.tickets_earned > 0">
                  <span>+{{ item.tickets_earned }}</span>
                  <span class="h-tix-lbl">tickets</span>
                </div>
                <div class="sim-chevron" [class.rotated]="expandedAttemptId === (item.attempt_id || item._id)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Expanded Details: Question-by-Question Breakdown -->
            <div class="sim-breakdown-section" *ngIf="expandedAttemptId === (item.attempt_id || item._id)">
              <div class="breakdown-header">
                <h4>Scene Breakdown & Answers ({{ item.review_questions?.length || item.total_questions }} Questions)</h4>
              </div>

              <div class="sim-questions-list" *ngIf="item.review_questions && item.review_questions.length > 0; else noQuestionsTeaser">
                <div class="sim-q-item" *ngFor="let rq of item.review_questions; let qi = index" [class.q-correct]="rq.is_correct" [class.q-wrong]="!rq.is_correct">
                  <div class="q-top-row">
                    <span class="scene-pill">SCENE {{ rq.scene_num || (qi + 1) }}</span>
                    <span class="q-result-badge" [class.correct]="rq.is_correct" [class.wrong]="!rq.is_correct">
                      <span *ngIf="rq.is_correct">✓ Correct Take (+{{ rq.points || 10 }} pts)</span>
                      <span *ngIf="!rq.is_correct">✗ Missed Cue</span>
                    </span>
                  </div>

                  <h5 class="q-title-text">{{ rq.question_text }}</h5>

                  <!-- Options Review Grid -->
                  <div class="q-options-grid" *ngIf="rq.options && rq.options.length > 0">
                    <div class="q-opt-card" *ngFor="let opt of rq.options"
                         [class.opt-user-correct]="opt.is_selected && opt.is_correct"
                         [class.opt-user-wrong]="opt.is_selected && !opt.is_correct"
                         [class.opt-is-correct]="!opt.is_selected && opt.is_correct">
                      <div class="opt-indicator">
                        <span class="opt-letter">{{ ['A','B','C','D'][opt.order] || '•' }}</span>
                        <span *ngIf="opt.is_selected && opt.is_correct" class="opt-tag tag-correct">✓ Your Take (Correct)</span>
                        <span *ngIf="opt.is_selected && !opt.is_correct" class="opt-tag tag-wrong">✗ Your Take (Wrong)</span>
                        <span *ngIf="!opt.is_selected && opt.is_correct" class="opt-tag tag-right-ans">★ Right Answer</span>
                      </div>
                      <span class="opt-text">{{ opt.option_text }}</span>
                    </div>
                  </div>

                  <!-- Quick Answers Summary Bar -->
                  <div class="q-answer-summary-bar">
                    <div class="summary-col user">
                      <span class="lbl">Your Answer:</span>
                      <span class="val" [class.correct]="rq.is_correct" [class.wrong]="!rq.is_correct">{{ rq.user_answer }}</span>
                    </div>
                    <div class="summary-col correct" *ngIf="!rq.is_correct">
                      <span class="lbl">Right Answer:</span>
                      <span class="val highlight">{{ rq.correct_answer }}</span>
                    </div>
                  </div>

                  <!-- Director's Cut Reason & Commentary -->
                  <div class="q-reason-box" *ngIf="rq.explanation">
                    <div class="reason-header">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                      </svg>
                      <span>DIRECTOR'S CUT REASONING & TRIVIA</span>
                    </div>
                    <p class="reason-text">{{ rq.explanation }}</p>
                  </div>
                </div>
              </div>

              <ng-template #noQuestionsTeaser>
                <div class="sim-empty-q">
                  <p>Detailed scene breakdown is synchronizing from archive.</p>
                </div>
              </ng-template>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- ── Daily Premiere Ticket Feature ───────────────────────────── -->
    <section class="daily-section" *ngIf="dailyQuiz">
      <div class="daily-inner">
        <div class="daily-card">
          <div class="ticket-stub-edge left"></div>

          <div class="daily-card-left">
            <div class="daily-film-icon">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <circle cx="12" cy="12" r="3.5"/>
                <line x1="12" y1="2" x2="12" y2="8.5"/>
                <line x1="12" y1="15.5" x2="12" y2="22"/>
                <line x1="2" y1="12" x2="8.5" y2="12"/>
                <line x1="15.5" y1="12" x2="22" y2="12"/>
              </svg>
            </div>
          </div>

          <div class="daily-card-body">
            <div class="daily-card-tags">
              <span class="daily-badge">TODAY'S PREMIERE</span>
              <span class="daily-bonus-tag">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
                <span>+50 Bonus Tickets</span>
              </span>
            </div>
            <h3 class="daily-title">{{ dailyQuiz.title }}</h3>
            <p class="daily-meta">
              <span class="meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span>{{ dailyQuiz.question_ids.length || '?' }} Questions</span>
              </span>
              <span class="sep">&middot;</span>
              <span class="meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <span>{{ dailyQuiz.time_limit ? dailyQuiz.time_limit + ' min' : '25s per question' }}</span>
              </span>
              <span class="sep">&middot;</span>
              <span class="meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                <span>Pass Score: {{ dailyQuiz.passing_score || 70 }}%</span>
              </span>
            </p>
          </div>

          <div class="daily-card-cta">
            <button class="btn-primary btn-cta" (click)="playDaily()" title="Enter Today's Screening">
              <span>Enter Screening</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </button>
          </div>

          <div class="ticket-stub-edge right"></div>
        </div>
      </div>
    </section>

    <!-- ── Screenings Catalog (Curated Repertoire) ──────────────────── -->
    <section class="quizzes-section" id="quizzes-section" *ngIf="recentQuizzes.length > 0">
      <div class="quizzes-inner">
        <div class="section-header">
          <div>
            <span class="section-eyebrow">
              <span class="sparkle">✦</span>
              <span>SCREENINGS REPERTOIRE</span>
            </span>
            <h2>Select Your Film Screening</h2>
            <p class="section-sub">Challenge your cinema intellect with specialized sets curated by true cinephiles.</p>
          </div>
          <span class="section-count">{{ recentQuizzes.length }} Screenings Available</span>
        </div>

        <div class="quiz-grid">
          <div class="quiz-card" *ngFor="let quiz of recentQuizzes" (click)="playQuiz(quizIdentifier(quiz))">
            <!-- Top Banner / Cover Artwork -->
            <div class="quiz-card-banner" [class.has-custom-img]="!!quiz.image_url">
              <img *ngIf="quiz.image_url" [src]="quiz.image_url" [alt]="quiz.title" class="quiz-banner-img" (error)="$any($event.target).style.display='none'" />
              
              <div class="quiz-banner-fallback" *ngIf="!quiz.image_url">
                <div class="fallback-glow"></div>
                <div class="fallback-icon">
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/>
                    <line x1="7" y1="2" x2="7" y2="22"/>
                    <line x1="17" y1="2" x2="17" y2="22"/>
                    <line x1="2" y1="12" x2="22" y2="12"/>
                    <line x1="2" y1="7" x2="7" y2="7"/>
                    <line x1="2" y1="17" x2="7" y2="17"/>
                    <line x1="17" y1="7" x2="22" y2="7"/>
                    <line x1="17" y1="17" x2="22" y2="17"/>
                  </svg>
                </div>
              </div>
              
              <div class="quiz-banner-overlay"></div>

              <!-- Badges placed atop the banner -->
              <div class="quiz-banner-badges">
                <span class="banner-cat-tag">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  <span>Featured Cut</span>
                </span>
                <div class="quiz-card-time-badge">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                  <span>{{ quiz.time_limit ? quiz.time_limit + ' min' : '25s / Q' }}</span>
                </div>
              </div>
            </div>

            <!-- Card Content Body -->
            <div class="quiz-card-content">
              <div class="quiz-card-body">
                <h3>{{ quiz.title }}</h3>
                <p *ngIf="quiz.description">{{ quiz.description }}</p>
                <div class="quiz-card-meta">
                  <span class="meta-pill">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/></svg>
                    <span>{{ quiz.question_ids.length || '?' }} Questions</span>
                  </span>
                  <span class="meta-pill" *ngIf="quiz.passing_score">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                    <span>{{ quiz.passing_score }}% to Pass</span>
                  </span>
                </div>
              </div>

              <div class="quiz-card-action">
                <span>Start Screening</span>
                <div class="quiz-card-arrow">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ── Category Fallback ───────────────────────────────────────── -->
    <section class="quizzes-section" *ngIf="recentQuizzes.length === 0 && categories.length > 0">
      <div class="quizzes-inner">
        <div class="section-header">
          <div>
            <span class="section-eyebrow">
              <span class="sparkle">✦</span>
              <span>GENRES & ERAS</span>
            </span>
            <h2>Explore by Genre</h2>
          </div>
        </div>
        <div class="quiz-grid">
          <div class="quiz-card" *ngFor="let cat of categories" (click)="playQuiz(categoryIdentifier(cat))">
            <div class="quiz-card-banner">
              <div class="quiz-banner-fallback">
                <div class="fallback-glow"></div>
                <div class="fallback-icon">
                  <span style="font-size: 1.65rem;">{{ cat.icon || '🎬' }}</span>
                </div>
              </div>
              <div class="quiz-banner-overlay"></div>
              <div class="quiz-banner-badges">
                <span class="banner-cat-tag">Genre Track</span>
              </div>
            </div>

            <div class="quiz-card-content">
              <div class="quiz-card-body">
                <h3>{{ cat.name }}</h3>
                <p *ngIf="cat.description">{{ cat.description }}</p>
                <div class="quiz-card-meta">
                  <span class="meta-pill">{{ cat.question_count }} Questions</span>
                </div>
              </div>
              <div class="quiz-card-action">
                <span>View Screening</span>
                <div class="quiz-card-arrow">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</div>

<app-footer></app-footer>
